import { useEffect, useState } from "react";
import { fetchProduct } from "../api/catalog";

export function useProductDetails(storeSlug, productHandle) {
  const [data, setData] = useState({ store: null, product: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);

    fetchProduct(storeSlug, productHandle, { signal: controller.signal })
      .then((result) => {
        setData(result);
        if (result?.product?.title && result?.store?.name) {
          document.title = `${result.product.title} | ${result.store.name}`;
        }
      })
      .catch((requestError) => {
        if (requestError.name !== "AbortError") setError(requestError);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [productHandle, reloadToken, storeSlug]);

  return {
    ...data,
    loading,
    error,
    retry: () => setReloadToken((current) => current + 1),
  };
}
